import React, { useRef, useEffect } from 'react';
import { Formik } from 'formik';
import { useToggle } from 'react-use';
import { Box, Grid } from "@mui/material";
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'hooks';
import { useCreatePromise } from 'hooks/api/cascade';
import { ActivityIndicator, AppBar, Page, ConfirmDialog } from 'components';
import { PromiseForm } from './components';
import { initialValues, validationSchema } from './NewPromiseScreen.mock';

const NewPromiseScreen = () => {
  const formRef = useRef();
  const history = useHistory();
  const { t } = useTranslation();
  const { entityId } = useParams();
  const { isLoading, isError, mutate } = useCreatePromise(entityId);
  const [isDialogOpened, toggleDialog] = useToggle(false);

  useEffect(() => {
    if (isError && formRef.current) {
      formRef.current.setSubmitting(false);
    }
  }, [isError]);

  const handleBackClick = () => {
    history.replace(`/cascades/${entityId}`);
  };

  const handlePromiseCreate = (formData) => {
    mutate(formData);

    toggleDialog();
  };

  return (
    <Page>
      <Grid container direction="column">
        <AppBar title={t('newPromise')} onNavClick={handleBackClick} navIcon="back" />

        <ConfirmDialog
          title={t('attention')}
          open={isDialogOpened}
          onConfirm={toggleDialog}
          confirmLabel={t('gotIt')}
          cancelLabel={null}
        >
          {t('promiseLongOperation')}
        </ConfirmDialog>

        <Grid item>
          <Box p={2}>
            <Formik
              initialValues={initialValues}
              innerRef={formRef}
              validationSchema={validationSchema}
              onSubmit={handlePromiseCreate}
              enableReinitialize
            >
              <PromiseForm entityId={entityId} />
            </Formik>
          </Box>
        </Grid>

        {isLoading && <ActivityIndicator />}
      </Grid>
    </Page>
  );
};

export default NewPromiseScreen;
